export default "__VITE_ASSET__B7w2IIJ___"